import styled from 'styled-components';

const CenteredSection = styled.section`
    display: flex;
    justify-content: center;
`

export default CenteredSection;